import { render } from "./AboutHeader.vue?vue&type=template&id=2c910f30&scoped=true"
import script from "./AboutHeader.vue?vue&type=script&lang=js"
export * from "./AboutHeader.vue?vue&type=script&lang=js"

import "./AboutHeader.vue?vue&type=style&index=0&id=2c910f30&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c910f30"]])

export default __exports__